var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPercentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.7512 67.6248H44.3162C41.1142 67.6248 38.5195 65.0301 38.5195 61.8281V37.4401C38.5195 36.1004 38.984 34.8053 39.828 33.7692L49.0455 22.5019C51.3633 19.666 55.6996 19.666 58.0174 22.5019L67.2349 33.7692C68.0834 34.8053 68.5434 36.1004 68.5434 37.4401V61.8281C68.5434 65.0301 65.9488 67.6248 62.7467 67.6248H62.7512Z",
    fill: "url(#paint0_linear_2323_17093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7512 67.6248H44.3162C41.1142 67.6248 38.5195 65.0301 38.5195 61.8281V37.4401C38.5195 36.1004 38.984 34.8053 39.828 33.7692L49.0455 22.5019C51.3633 19.666 55.6996 19.666 58.0174 22.5019L67.2349 33.7692C68.0834 34.8053 68.5434 36.1004 68.5434 37.4401V61.8281C68.5434 65.0301 65.9488 67.6248 62.7467 67.6248H62.7512Z",
    fill: "url(#paint1_linear_2323_17093)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2323_17093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8312 40.0613L59.3307 25.5831C58.9511 21.9389 55.3338 19.5542 51.837 20.6483L37.9438 24.9846C36.6665 25.3821 35.5679 26.2127 34.8311 27.3292L21.4112 47.6935C19.6517 50.3685 20.3885 53.9635 23.0636 55.7231L38.4573 65.865C41.1324 67.6245 44.7274 66.8877 46.4869 64.2126L59.9023 43.8484C60.6392 42.7319 60.9652 41.3922 60.8268 40.0613H60.8312ZM56.7316 28.9548C55.4633 30.8795 52.8776 31.411 50.9528 30.1427C49.028 28.8744 48.4966 26.2887 49.7649 24.3639C51.0332 22.4391 53.6189 21.9077 55.5437 23.176C57.4685 24.4443 57.9999 27.03 56.7316 28.9548Z",
    fill: "url(#paint2_linear_2323_17093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4147 39.6857L58.9571 25.622C58.6021 22.2134 55.219 19.9836 51.9492 21.0067L51.9489 21.0068L38.0557 25.3432L38.0554 25.3433C36.8617 25.7147 35.8341 26.4913 35.1446 27.5361L21.725 47.8999C20.0791 50.4021 20.7688 53.7641 23.27 55.4093L23.2702 55.4094L38.6637 65.5512L60.4147 39.6857ZM60.4147 39.6857H60.4101L60.4532 40.1002C60.5827 41.3449 60.2777 42.5978 59.5889 43.6415L59.5887 43.6417L46.1733 64.006L46.1731 64.0062C44.528 66.5074 41.1662 67.197 38.664 65.5513L60.4147 39.6857ZM50.7461 30.4563C52.8441 31.8387 55.6628 31.2594 57.0452 29.1614C58.4276 27.0635 57.8483 24.2448 55.7503 22.8623C53.6524 21.4799 50.8337 22.0592 49.4512 24.1572C48.0688 26.2552 48.6481 29.0739 50.7461 30.4563Z",
    stroke: "url(#paint3_linear_2323_17093)",
    strokeWidth: 0.751175
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9345 54.4492C39.6826 54.5946 39.4873 54.5474 39.3488 54.3075C39.3073 54.2355 39.2932 54.1556 39.3065 54.068L41.4249 37.2495C41.4465 37.0931 41.482 36.9606 41.5314 36.8521C41.5807 36.7437 41.6834 36.6444 41.8393 36.5544L42.793 36.0037C43.045 35.8583 43.2402 35.9055 43.3787 36.1455C43.4203 36.2174 43.4344 36.2973 43.421 36.385L41.3026 53.2034C41.281 53.3599 41.2455 53.4923 41.1962 53.6008C41.1588 53.7023 41.0562 53.8016 40.8882 53.8985L39.9345 54.4492ZM48.6523 49.5599C47.8485 50.024 47.0846 50.1691 46.3604 49.9954C45.6363 49.8216 45.0425 49.3887 44.5789 48.6966C44.3868 48.3916 44.225 48.1252 44.0934 47.8973C43.9618 47.6693 43.805 47.3839 43.6231 47.0411C43.2555 46.2936 43.1655 45.5698 43.3531 44.8697C43.5527 44.1626 44.0724 43.5667 44.9122 43.0818C45.7639 42.5901 46.5398 42.438 47.24 42.6256C47.9521 42.8063 48.534 43.2461 48.9855 43.9451C49.2034 44.2672 49.3782 44.5422 49.5098 44.7701C49.6414 44.998 49.7852 45.2749 49.9413 45.6006C50.3209 46.3412 50.3989 47.0719 50.1753 47.7929C49.9637 48.5068 49.456 49.0959 48.6523 49.5599ZM47.8419 48.1563C48.1058 48.004 48.2786 47.8322 48.3602 47.6411C48.4539 47.4431 48.4882 47.2394 48.4632 47.0299C48.4382 46.8204 48.3772 46.6316 48.2803 46.4637C48.1311 46.1499 47.9976 45.8911 47.8799 45.6871C47.7552 45.4712 47.6012 45.2322 47.4179 44.9701C47.2466 44.7011 47.0172 44.4977 46.7297 44.3598C46.4352 44.2099 46.096 44.2458 45.7121 44.4674C45.3402 44.6821 45.1456 44.9545 45.1281 45.2844C45.1038 45.6024 45.1593 45.9063 45.2946 46.1961C45.4419 46.4789 45.5779 46.7283 45.7025 46.9442C45.8203 47.1482 45.9717 47.3966 46.1569 47.6896C46.2778 47.8437 46.4168 47.9874 46.5737 48.1207C46.7427 48.2471 46.9303 48.3228 47.1366 48.3476C47.3549 48.3655 47.59 48.3018 47.8419 48.1563ZM37.7946 47.3351C36.9908 47.7992 36.2338 47.9563 35.5235 47.8065C34.8133 47.6568 34.2263 47.2359 33.7628 46.5438C33.5707 46.2388 33.4089 45.9724 33.2773 45.7444C33.1388 45.5045 32.9785 45.2131 32.7966 44.8703C32.429 44.1228 32.339 43.399 32.5266 42.6988C32.7262 41.9918 33.2459 41.3958 34.0856 40.911C34.9374 40.4192 35.7133 40.2672 36.4135 40.4548C37.1256 40.6354 37.7075 41.0753 38.159 41.7743C38.3769 42.0963 38.5552 42.3773 38.6937 42.6173C38.8253 42.8452 38.9691 43.122 39.1252 43.4478C39.5048 44.1884 39.5759 44.9071 39.3384 45.604C39.113 46.294 38.5984 46.8711 37.7946 47.3351ZM37.0258 46.0035C37.2897 45.8511 37.4625 45.6794 37.5441 45.4883C37.6377 45.2903 37.672 45.0865 37.6471 44.877C37.6221 44.6675 37.5576 44.4728 37.4537 44.2929C37.3046 43.9791 37.1711 43.7202 37.0534 43.5163C36.9287 43.3004 36.7747 43.0614 36.5914 42.7993C36.4201 42.5303 36.1907 42.3269 35.9032 42.189C35.6156 42.0511 35.2799 42.0929 34.896 42.3146C34.5241 42.5293 34.326 42.7956 34.3016 43.1136C34.2773 43.4316 34.3388 43.732 34.4861 44.0148C34.6334 44.2977 34.7693 44.5471 34.894 44.763C35.0118 44.9669 35.1632 45.2154 35.3484 45.5084C35.4643 45.6814 35.6007 45.8346 35.7576 45.9679C35.9266 46.0943 36.1142 46.1699 36.3205 46.1948C36.5388 46.2127 36.7739 46.1489 37.0258 46.0035Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2323_17093",
    x: 6.93392,
    y: 6.85971,
    width: 67.4447,
    height: 73.4818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.76058
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2323_17093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2323_17093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2323_17093",
    x1: 53.5337,
    y1: 69.5272,
    x2: 53.5337,
    y2: 22.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFCA40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2323_17093",
    x1: 53.5337,
    y1: 69.5272,
    x2: 53.5337,
    y2: 22.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFCA40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2323_17093",
    x1: 22.7361,
    y1: 64.1993,
    x2: 63.5364,
    y2: 28.7032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2323_17093",
    x1: 23.3071,
    y1: 24.0333,
    x2: 62.1122,
    y2: 60.1308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercentSmall);
export default __webpack_public_path__ + "static/media/icon-percent-small.a7a59cfea237ac77838d1f37f9265c11.svg";
export { ForwardRef as ReactComponent };